import styled from 'styled-components';
import ExpressCareSvg from '../../../assets/onboardingNew/homepage/express-care.svg';

const ExpressCareNewIcon = styled(ExpressCareSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.6rem'};
height: ${props => props.height || '3.6rem'};
display: flex;
`;

export default ExpressCareNewIcon;
